import { Routes } from '@angular/router';
import { AuthorizeComponent } from './components/authorize/authorize.component';
import { CallbackComponent } from './components/callback/callback.component';

export const routes: Routes = [
  {
    path: '',
    component: AuthorizeComponent
  },
  {
    path: 'callback',
    component: CallbackComponent
  }
];

